import React from "react";
import { ReactFormGenerator } from "react-form-builder2";
import * as variables from "utils/ReactFormBuilderVariables";
import MyButton from "../MyButton/index";
import { FormActions } from "./Theme";

const FormGeneratorComponent = ({ answerData, formData, enableEdit, setEnableEdit, isLoading, onUpdateForm, onCancel, saveDisabled }) => {
  return (
    <ReactFormGenerator
      variables={variables}
      answer_data={answerData || []}
      data={formData || []}
      read_only={!enableEdit}
      hide_actions={!enableEdit}
      skip_validations={true}
      onSubmit={enableEdit ? (data) => {
        onUpdateForm(data);
      } : null}
      submitButton={enableEdit ? (
        <FormActions>
            <MyButton
              type={"secondary"}
              content={"Cancel"}
              onClick={(e) => {
                e.preventDefault();
                if (onCancel) onCancel();
                else setEnableEdit(false);
              }}
              style={{ width: "130px" }}
            />
            <MyButton
              type={"primary"}
              content={isLoading ? <span className="spinner spinner-gray mr-4"></span> : "Save"}
              style={{ width: "130px" }}
              disabled={isLoading || saveDisabled}
              onClick={(e) => {
                // MyButton always renders a DOM <button type="button">, so it
                // can never natively submit the surrounding <form> that
                // react-form-builder2 relies on for its onSubmit handler.
                // Trigger the submit programmatically instead.
                const formEl = e.target.closest("form");
                if (!formEl) return;
                if (formEl.requestSubmit) {
                  formEl.requestSubmit();
                } else {
                  formEl.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
                }
              }}
            />
        </FormActions>
      ) : null}
      disabled={!enableEdit}
    />
  );
};

export default FormGeneratorComponent;
